"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
require("react");
const Spinner_1 = tslib_1.__importDefault(require("../spinner/Spinner"));
const DropdownSpinner = ({ className }) => ((0, jsx_runtime_1.jsx)("ul", Object.assign({ className: className }, { children: (0, jsx_runtime_1.jsx)("div", Object.assign({ className: 'display-flex justify-content-center padding-10' }, { children: (0, jsx_runtime_1.jsx)(Spinner_1.default, {}) })) })));
exports.default = DropdownSpinner;
